module.exports = "a {\n  font-size: 10px;\n}\n"